<template>
  <div>
    <label v-if="label.length > 0" class="text-gray-700 font-semibold text-base ml-2 mb-1 inline-block">{{ label }}</label>
    <form-antd-date-picker
      v-bind="$attrs"
      :mode="mode"
      v-model="antdDatePickerValue"
      :placeholder="placeholder"
      :format="format"
      :type="type"
      class="w-full"
      :clearable="clearable"
      :inputReadOnly="inputReadOnly"
      ref="antdDatePicker"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone.js'
import FormAntdDatePicker from './AntDesign/FormAntdDatePicker.vue'
dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  components: {
    FormAntdDatePicker
  },
  props: {
    /**
     * Current date object.
     * @model
     */
    modelValue: {
      // default: new Date().toString()
    },
    /**
     * Change the type of date picker to display:
     * single - single date,
     * multiple - allows you to choose multiple dates in one picker.
     * range - allows you to choose a start and end date.
     */
    mode: {
      type: String,
      default: 'single'
    },
    /**
     * Placeholder.
     */
    placeholder: {
      type: [String, Array],
      default: () => ''
    },
    /**
     * Optional label above the employee picker.
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Option to determine if selectedDate can be set to null.
     */
    clearable: {
      type: Boolean,
      default: false
    },
    /**
     * Timezone to use for dayjs
     */
    timezone: {
      type: String,
      default: dayjs.tz.guess()
    },
    /**
     * Format to use for dayjs
     */
    format: {
      type: String,
      default: 'M/D/YYYY'
    },
    /**
     * Type to use for datepicker (date | week | month | quarter | year)
     */
    type: {
      type: String,
      default: 'date'
    },
    /**
     * Set the readonly attribute of the input tag
     */
    inputReadOnly: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  computed: {
    antdDatePickerValue: {
      get() {
        return this.modelValue || null
      },
      set(val) {
        this.$emit('update:modelValue', val || null)
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    clearValue() {
      switch (this.mode) {
        case 'range':
          let ts = { start: '', end: '' }
          this.$emit('update:modelValue', ts)
          break
        case 'single':
          this.$emit('update:modelValue', null)
          break
        case 'multiple':
          this.$emit('update:modelValue', [])
          break
        default:
      }
    },
    openDatePicker() {
      if (this.$refs.antdDatePicker) {
        this.$refs.antdDatePicker?.openDatePicker()
      }
    },
    closeDatePicker() {
      if (this.$refs.antdDatePicker) {
        this.$refs.antdDatePicker?.closeDatePicker()
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
div :deep(input) {
  outline: none;
}
</style>
